/* MIKORA · Cart Boost: upsell de 1 clic dentro del carrito nativo */
(function () {
  if (window.__mkCartBoost) return;
  window.__mkCartBoost = true;

  var SECTIONS = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];

  function swapSection(id, html) {
    var el = document.getElementById(id);
    if (!el || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var inner = doc.querySelector('.shopify-section');
    el.innerHTML = inner ? inner.innerHTML : html;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mk-add]');
    if (!btn) return;
    e.preventDefault();
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Añadiendo…';

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(btn.dataset.mkAdd), quantity: 1 }],
        sections: SECTIONS.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.status >= 400) throw new Error(data.description || 'error');
        if (data.sections) {
          Object.keys(data.sections).forEach(function (id) { swapSection(id, data.sections[id]); });
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'mikora-upsell' } }));
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
      });
  });
})();
